




























































import { Component, Prop, Vue } from 'vue-property-decorator'
import OptionModule from '@/components/OptionModule.vue'
import GlassColorCollection from '@/data/glasscolorcollection'
import GlassColor from '@/data/glasscolor'
import GlassOptionValue from '@/data/glass-option-value'
import { ModuleOption } from '@/data/enums'
import GlassOption from '@/data/glass-option'

@Component({
  components: {
    OptionModule
  }
})
export default class ColorSubModule extends Vue {
  @Prop() private colorSet!: string
  @Prop() private optionId!: ModuleOption
  private items: GlassColor[] = []
  private currentPage: number = 0
  private pageSize: number = 8
  private position: number = 0
  private containerWidth: number = 0

  private get showPrice (): boolean {
    return this.$store.state.data.optician.showPrices
  }
  private get colorOptions () {
    return this.$store.state.data.colors.filter((color: GlassColor) => (color.colorSetId === this.colorSet))
  }

  private get price (): number {
    if (this.$store.state.cart.currentItem && this.$store.state.cart.currentItem.type) {
      const currentOption = this.$store.state.cart.currentItem.type.options
        .find((option: GlassOption) => option.optionId === this.optionId)
      if (currentOption) {
        const selectedValue = currentOption.values.find((value: GlassOptionValue) => (value.selected))
        if (selectedValue) {
          return selectedValue.price
        }
      }
    }
    return 0
  }

  private get pages (): GlassColorCollection[] {
    const pages = []
    let currentPageCounter = 0
    let currentPageIndex = 0
    let page = new GlassColorCollection()
    page.index = currentPageIndex
    pages.push(page)

    for (const color of this.colorOptions) {
      page.items.push(color)
      if (currentPageCounter >= this.pageSize - 1) {
        pages.push(page)
        currentPageCounter = 0
        currentPageIndex++
        page = new GlassColorCollection()
        page.index = currentPageIndex
        pages.push(page)
      } else {
        currentPageCounter++
      }
    }
    this.containerWidth = pages.length * 1600
    if (this.containerWidth <= 1600) {
      this.containerWidth = 1600
    }
    return pages
  }

  private get previousRoute (): string {
    return this.$store.state.route.from.fullPath
  }

  private get colorSetTitle (): string {
    if (this.$store.state.cart.currentItem && this.$store.state.cart.currentItem.type) {
      const currentOption = this.$store.state.cart.currentItem.type.options
        .find((option: GlassOption) => option.optionId === this.optionId)
      if (currentOption) {
        const selectedValue = currentOption.values.find((value: GlassOptionValue) => (value.selected))
        if (selectedValue) {
          return selectedValue.name
        }
      }
    }
    return 'module_colorselection_title'
  }

  private isSelected (option: GlassOption, color: GlassColor): boolean {
    const selectedValue = option.values.find((value: GlassOptionValue) => (value.selected))
    if (selectedValue && selectedValue.colorSelection) {
      return (selectedValue.colorSelection.id === color.id)
    }
    return false
  }

  private selectColor (option: GlassOption, color: GlassColor) {
    const selectedValue = option.values.find((value: GlassOptionValue) => (value.selected))
    if (selectedValue) {
      selectedValue.colorSelection = color
      selectedValue.subSelection = color.name
      selectedValue.selected = false
      this.toggleOptionValue(selectedValue)
    }
  }

  private selectPage (index: number) {
    if (index !== this.currentPage) {
      this.currentPage = index
    }
  }

  private toggleOptionValue (optionValue: GlassOptionValue) {
    this.$store.dispatch('cart/toggleOptionValue', optionValue)
      .catch((err) => console.error(err))
  }
}
